export const docTypeForm: any = {
  id: "",
  documentTypeName: "",
  reviewFrequency: "",
  revisionRemind: 30,
  documentNumbering: "",
  prefix: [],
  suffix: [],
  readAccess: "",
  creators: [],
  reviewers: [],
  approvers: [],
  users: [],
  applicable_systems: [],
  document_classification: "",
  locationId: [],
  distributionList: "None",
  freeTextValue: "",
  currentVersion: "",
  distributionUsers: [],
  readAccessUsers: [],
};
